// export function printPayment(data) {
//   try {
//     const iframe = document.createElement("iframe");

//     iframe.style.position = "fixed";
//     iframe.style.right = "0";
//     iframe.style.bottom = "0";
//     iframe.style.width = "0";
//     iframe.style.height = "0";
//     iframe.style.border = "0";

//     document.body.appendChild(iframe);

//     const doc = iframe.contentWindow.document;

//     const rows = data.details.map(
//       (item) => `
//             <div style="display:flex;justify-content:space-between;">
//               <div>${item.year} ${item.month_name}</div>
//               <div style="font-weight:600">
//                 ${item.amount.toLocaleString()}
//               </div>
//             </div>
//           `
//     ).join("");

//     doc.open();
//     doc.write(`
//       <html>
//         <head>
//           <title>Bukti Pembayaran ${data.header.paycode}</title>
//           <style>
//             @page {
//               size: 58mm auto;
//               margin: 0;
//             }

//             body {
//               font-family: monospace;
//               width: 58mm;
//               padding: 6px;
//               font-size: 11px;
//             }

//             .center { text-align: center; }
//             .right { text-align: right; }
//             .bold { font-weight: bold; }
//             .small { font-size: 10px; }

//             .line {
//               border-top: 1px dashed #000;
//               margin: 6px 0;
//             }

//             .row {
//               margin-bottom: 4px;
//             }
//           </style>
//         </head>
//         <body>

//           <div class="center bold">PDK Betania</div>
//           <div class="center small">Bukti Setoran Iuran Anggota</div>

//           <div class="line"></div>


//           <div class="bold">${data.header.paycode}</div>
//            <div class="bold">${data.header.membercode}</div>
//             <div class="bold">${data.header.name_full}</div>

//           <div class="line"></div>

//           ${rows}

//           <div class="line"></div>

//           <div class="row right bold">
//             TOTAL:  ${data.summary.total_amount.toLocaleString()}
//           </div>

//           <div class="line"></div>

//           <div class="center small">
//             Terima kasih 🙏<br/>
//             ${new Date().toLocaleString("id-ID")}
//           </div>

//           <script>
//             window.onload = function () {
//               window.print();
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     doc.close();

//     iframe.contentWindow.onafterprint = () => {
//       document.body.removeChild(iframe);
//     };
//   } catch (e) {
//     alert("Gagal mencetak. Periksa printer." + e);
//     console.error(e);
//   }
// }



function buildHtml(data, isMobile = false) {
  const rows = data.details.map(
    (item) => `
      <div style="display:flex;justify-content:space-between;">
        <div>${item.year} ${item.month_name}</div>
        <div style="font-weight:600">
          ${item.amount.toLocaleString()}
        </div>
      </div>
    `
  ).join("");

  return `
    <html>
      <head>
        <title>Bukti Pembayaran ${data.header.paycode}</title>
        ${isMobile ? `<meta name="viewport" content="width=device-width, initial-scale=1">` : ""}
        <style>
          @page { size: 58mm auto; margin: 0; }
          body {
            font-family: monospace;
            width: 58mm;
            padding: 6px;
            font-size: 11px;
          }
          .center { text-align: center; }
          .right { text-align: right; }
          .bold { font-weight: bold; }
          .small { font-size: 10px; }
          .line { border-top: 1px dashed #000; margin: 6px 0; }
          .row { margin-bottom: 4px; }
        </style>
      </head>
      <body>
        <div class="center bold">PDK Betania</div>
        <div class="center small">Bukti Setoran Iuran Anggota</div>

        <div class="line"></div>

        <div class="bold">${data.header.paycode}</div>
        <div class="bold">${data.header.membercode}</div>
        <div class="bold">${data.header.name_full}</div>

        <div class="line"></div>

        ${rows}

        <div class="line"></div>

        <div class="row right bold">
          TOTAL: ${data.summary.total_amount.toLocaleString()}
        </div>

        <div class="line"></div>

        <div class="center small">
          Terima kasih 🙏<br/>
          ${new Date().toLocaleString("id-ID")}
        </div>
      </body>
    </html>
  `;
}


function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function printPayment(data) {
  try {
    if (isAndroid()) {
      printViaWindow(data);
    } else {
      printViaIframe(data);
    }
  } catch (e) {
    alert("Gagal mencetak. Periksa printer.");
    console.error(e);
  }
}

function printViaIframe(data) {
  const iframe = document.createElement("iframe");

  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(buildHtml(data));
  doc.close();

  iframe.contentWindow.onload = () => {
    iframe.contentWindow.print();
  };

  iframe.contentWindow.onafterprint = () => {
    document.body.removeChild(iframe);
  };
}

function printViaWindow(data) {
  const win = window.open("", "_blank");

  win.document.open();
  win.document.write(buildHtml(data, true));
  win.document.close();

  win.onload = () => {
    win.print();
    setTimeout(() => win.close(), 500);
  };
}


const LF = "\n";

// function RawPrintingESCPOS(data) {
//   let raw = "";

//   // INIT
//   raw += "\x1B\x40";

//   // TITLE
//   raw += "\x1B\x61\x01"; // center
//   raw += "BETANIA" + LF;
//   raw += "\x1B\x61\x00"; // left

//   raw += "--------------------------------" + LF;

//   // HEADER
//   raw += `PayCode : ${data.header.paycode}` + LF;
//   raw += `Date    : ${data.header.date}` + LF;
//   raw += `Member  : ${data.header.membercode}` + LF;
//   raw += `Name    : ${data.header.name_full}` + LF;

//   raw += "--------------------------------" + LF;

//   // DETAILS
//   data.details.forEach(item => {
//     const monthYearStr = `${item.month_name} ${item.year}`;
//     const amountStr = item.amount.toLocaleString();

//     raw += monthYearStr;
//     raw += " ".repeat(55 - monthYearStr.length - amountStr.length);
//     raw += amountStr+ LF + LF;
//   });

//   raw += "--------------------------------" + LF;


//   const total_amountStr = data.summary.total_amount.toLocaleString();
//   // TOTAL
//   raw += "TOTAL";
//   raw += " ".repeat(55 - 5 - total_amountStr.length);
//   raw += total_amountStr + LF;

//   raw += "--------------------------------" + LF;

//   // FOOTER
//   raw += "\x1B\x61\x01"; // center
//   raw += "TERIMA KASIH" + LF + LF;

//   // CUT
//   raw += "\x1D\x56\x00";

//   return raw; // ⬅️ RAW ESC/POS
// }


function RawPrintingESCPOS(data) {
  const LF = "\n";
  const LINE_WIDTH = 32;
  let raw = "";

  // INIT
  raw += "\x1B\x40";

  // ===== TITLE (BIG FONT) =====
  raw += "\x1B\x61\x01";      // center
  raw += "\x1D\x21\x11";      // double width + double height
  raw += "BETANIA" + LF;
  raw += "\x1D\x21\x00";      // normal size
  raw += "PEMBAYARAN IURAN" + LF;
  raw += "\x1B\x61\x00";      // left

  raw += "-".repeat(LINE_WIDTH) + LF;

  // console.log('Raw Data:', data);
  // ===== HEADER =====
  // raw += `PayCode : ${data.header.paycode}` + LF;
  // raw += `Date    : ${data.header.date}` + LF;
  // raw += `Member  : ${data.header.membercode}` + LF;
  // raw += `Name    : ${data.header.name_full}` + LF;
  const name = data?.header?.name_full || "";
  raw += name.slice(0, 32) + LF;
  raw += data?.header?.membercode + LF;
  raw += data?.header?.date + LF;
  raw += data?.header?.paycode + LF;

  raw += "=".repeat(LINE_WIDTH) + LF;

  // ===== DETAILS =====
  data?.details?.forEach(item => {
    const left = `${item.month_name} ${item.year}`;
    const right = item.amount.toLocaleString();

    const space = LINE_WIDTH - left.length - right.length;
    raw += left + " ".repeat(Math.max(space, 1)) + right + LF;
  });

  raw += "-".repeat(LINE_WIDTH) + LF;

  // ===== TOTAL (1 BARIS) =====
  const totalStr = data?.summary?.total_amount?.toLocaleString();
  const totalLabel = "TOTAL";

  const totalSpace = LINE_WIDTH - totalLabel.length - totalStr.length;
  raw += totalLabel + " ".repeat(Math.max(totalSpace, 1)) + totalStr + LF;

  raw += "-".repeat(LINE_WIDTH) + LF;

  // ===== FOOTER =====
  raw += "\x1B\x61\x01"; // center
  raw += "TERIMA KASIH" + LF + LF;
  raw += "TUHAN YESUS MEMBERKATI" + LF + LF + LF + LF;

  // ===== CUT =====
  raw += "\x1D\x56\x00";

  return raw;
}


export default { printPayment, RawPrintingESCPOS };
